import { usePunditUserContext } from "@circle-react/contexts";

export const useIsPaywallsModalsV3 = () => {
  const { currentCommunitySettings } = usePunditUserContext();
  return Boolean(
    currentCommunitySettings?.paywalls_migrate_paywall_forms_enabled,
  );
};
